import { render, staticRenderFns } from "./NoticiasCard.vue?vue&type=template&id=3a17bdd0"
import script from "./NoticiasCard.vue?vue&type=script&lang=js"
export * from "./NoticiasCard.vue?vue&type=script&lang=js"
import style0 from "./NoticiasCard.vue?vue&type=style&index=0&id=3a17bdd0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports